export default "__VITE_ASSET__BVRUdww7__"